export default __webpack_public_path__ + "static/collection-61da24c49c72563982855a79c40cb919.webp";